module.exports = __webpack_public_path__ + "img/7_en.0a65600.png";